import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=bbc01b44"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc01b44')) {
      api.createRecord('bbc01b44', component.options)
    } else {
      api.reload('bbc01b44', component.options)
    }
    module.hot.accept("./Album.vue?vue&type=template&id=bbc01b44", function () {
      api.rerender('bbc01b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/album/Album.vue"
export default component.exports